import { getCurrencyCode } from '@helpers/env'

function getCurrencySymbol() {
  const currencyCode = getCurrencyCode()

  if (currencyCode === 'EUR') {
    return '€'
  }

  if (currencyCode === 'USD') {
    return '$'
  }

  return `£`
}

export const TEMPLATE_SEARCHRESULTS_TOTALCOUNT = `
  <div class="number-of-results">
    {{#unless total_hits }}<h2>Top rated favourites...</h2>{{/unless}}
    {{total_hits}}{{#equals total_hits 10000}}+{{/equals}}{{#if resultcount}} products{{/if}}
  </div>
`

const TEMPLATE_SEARCHRESULTS_IMAGE = `
  <div class="ProductItem__imageContainer ProductItem_imagePlaceholder {{document_type}}">
  {{#if images.main}}
    <img class="ProductItem__mainImage" src="{{images.main}}" alt="{{#if title}}{{title}}{{/if}}">
  {{/if}}
    {{#if custom_fields.tag }}  
      <div class="ProductItem__tag">{{custom_fields.tag}}</div>
    {{/if}}
    {{#if custom_fields.images}}
      <div class="ProductItem__image">
       {{#each custom_fields.images}}
        {{#if @first}}
            <img class="ProductItem__secondaryImage" src="{{this}}&width=357&height=447&crop=center" alt="{{#if title}}{{title}}{{/if}}">
        {{/if}}
        {{#if @last}}
            <img class="ProductItem__primaryImage" src="{{this}}&width=357&height=447&crop=center" alt="{{#if title}}{{title}}{{/if}}">
        {{/if}}
       {{/each}}
      </div>
    {{/if}}
  </div>
`

const TEMPLATE_SEARCHRESULTS_DETAILS = `
  <div class="ProductDetails">
    <div class="ProductDetails__mainDetails">
      <h3 class="ProductDetails__color">{{custom_fields.product_type}}</h3>
      {{#if type}}
      {{ else }}
      <div class="ProductDetails__prices">
        <p data-price="{{custom_fields.compare_at_price}}" class="ProductDetails__fullPrice {{#not custom_fields.compare_at_price 0.00}}hidden{{/not}}">
          {{#not custom_fields.compare_at_price 0.00}}${getCurrencySymbol()}{{custom_fields.compare_at_price}}{{/not}}
        </p>
        
        <p data-price="{{custom_fields.price}}" class="ProductDetails__priceComparison">
          ${getCurrencySymbol()}{{custom_fields.price}}
        </p>
      </div>
      {{/if}}
    </div>
    <h4 class="ProductDetails__productType">{{#if type}}{{highlight}}{{else}}{{title}}{{/if}}</h4>
  </div>
`

const DEFAULT_SEARCH_RESULTS_TEMPLATE = `
  <li class="ProductItem" key="{{id}}">
      <a href="/pages/search?search=Sharps" data-analytics-click="{{id}}">
       <div class="ProductItem__imageContainer ProductItem_imagePlaceholder {{document_type}}">
          <div class="ProductItem__image">
            <img class="ProductItem__primaryImage" src="https://images.ctfassets.net/amhdwl2zsv5z/27MChz6rvxjhxP5d3nmUl4/54a08211ac838875cb3f9695dd10f174/Search_Breakdown_SS25_Sharps.jpg?w=486&q=80" alt="Sharps">
          </div>
        </div>
        <div class="ProductDetails ProductDetails__noPadding">
          <h3 class="ProductDetails__color">Sharps</h3>
        </div>
      </a>
    </li>
    <li class="ProductItem" key="{{id}}">
      <a href="/pages/search?search=Fives" data-analytics-click="{{id}}">
       <div class="ProductItem__imageContainer ProductItem_imagePlaceholder {{document_type}}">
          <div class="ProductItem__image">
            <img class="ProductItem__primaryImage" src="https://images.ctfassets.net/amhdwl2zsv5z/4XpCFdFYk2S472g2DGI2qq/e754c6f5a642ac140a53f705213ef231/Search_Breakdown_SS25_Fives.jpg?w=486&q=80" alt="Fives">
          </div>
        </div>
        <div class="ProductDetails ProductDetails__noPadding">
          <h3 class="ProductDetails__color">Fives</h3>
        </div>
      </a>
    </li>
    <li class="ProductItem" key="{{id}}">
      <a href="/pages/search?search=T-Shirts" data-analytics-click="{{id}}">
       <div class="ProductItem__imageContainer ProductItem_imagePlaceholder {{document_type}}">
          <div class="ProductItem__image">
            <img class="ProductItem__primaryImage" src="https://images.ctfassets.net/amhdwl2zsv5z/Pebbl5KWp2u8w6Eaj7nI4/05803e51aa34511122a0c671700daaa9/Search_Breakdown_SS25_Tees.jpg?w=486&q=80" alt="T-Shirts">
          </div>
        </div>
        <div class="ProductDetails ProductDetails__noPadding">
          <h3 class="ProductDetails__color">T-Shirts</h3>
        </div>
      </a>
    </li>
    <li class="ProductItem" key="{{id}}">
      <a href="/pages/search?search=Shorts" data-analytics-click="{{id}}">
       <div class="ProductItem__imageContainer ProductItem_imagePlaceholder {{document_type}}">
          <div class="ProductItem__image">
            <img class="ProductItem__primaryImage" src="https://images.ctfassets.net/amhdwl2zsv5z/2ih03jz1r0M15PCSn9NgKZ/4a537808726ebdc6b7bdf6acf59a3e9b/Search_Breakdown_SS25_Shorts.jpg?w=486&q=80" alt="Smarts">
          </div>
        </div>
        <div class="ProductDetails ProductDetails__noPadding">
          <h3 class="ProductDetails__color">Shorts</h3>
        </div>
      </a>
    </li>
`

export const TEMPLATE_SEARCHRESULTS = `
  ${TEMPLATE_SEARCHRESULTS_TOTALCOUNT}
  <ul class="ProductList">
    {{#unless hits }}
       ${DEFAULT_SEARCH_RESULTS_TEMPLATE}
    {{/unless}}
    {{#each hits}}
      <li class="ProductItem" key="{{id}}">
        <a href="{{url}}" data-analytics-click="{{id}}">
          ${TEMPLATE_SEARCHRESULTS_IMAGE}
          ${TEMPLATE_SEARCHRESULTS_DETAILS}
        </a>
      </li>
    {{/each}}
  </ul>
`

export const TEMPLATE_SEARCHRESULTS_NORESULTS = `
  <div class="addsearch-searchresults addsearch-searchresults-no-results">
    <h2>We don't have anything matching your keyword <em>{{keyword}}</em> please try a different term or explore our range <a class="link primary" href="/">here</a></h2>
  </div>
`
